import React from 'react'
import InfoList from './InfoList'
import GetInTouch from './GetInTouch'
import RecommendedReads from '../../../shared/BrandPages/RecommendedReads'
import BlueSection from '../../../shared/BrandPages/BlueSection'
import BrandSection from '../../../shared/BrandPages/BrandSection'
import Section from '../../../shared/BrandPages/Section'
import { contactUsData } from './consts'
import Content from '../../../shared/BrandPages/Content'
import CustomJsonLd from '../../../shared/CustomJsonLd'
import { jsonLdData } from '../../../../common/constants/jsonLd'
import HeroSection from '../../../shared/Rewrite/BrandPages/HeroSection'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { defaultPhoneNumber } from 'src/common/utils'

const ContactUs = () => {
  const {
    seo,
    heroData,
    hereToHelpData,
    info,
    openHoursData,
    workingHours,
    officeLocationsData,
    recommendedReadsData,
  } = contactUsData

  return (
    <Content classNames={'bg-blue-base-white'}>
      <WithSeoOverrides {...seo} />
      <CustomJsonLd
        id={'webPage'}
        data={jsonLdData(seo?.title, seo?.description, '/contact/')}
      />
      <Section classNames={`pb-0 pt-0 bg-white lg:pl-8 xl:pl-0`}>
        <HeroSection
          {...heroData}
          showTrustpilot
          contentClassName="-bottom-14 lg:pt-2 mx-4 p-6"
          heroContainerClassName="pb-14 lg:pb-0 lg:pl-4"
          imgClassName="object-top-0.38 bg-white -scale-x-100 lg:scale-x-100"
          imgContainerClassName="lg:h-600"
          richTextClassName="max-w-130 lg:max-w-none"
          phone={defaultPhoneNumber}
        />
      </Section>
      <Section classNames="bg-blue-base-white">
        <BrandSection
          {...hereToHelpData}
          childClassName="order-3 lg:order-last pt-10"
          wrapperClassName="mt-7 lg:mt-0"
        >
          <InfoList list={info} id="getInTouch-list" />
        </BrandSection>
      </Section>
      <Section classNames="bg-white">
        <BrandSection
          {...openHoursData}
          childClassName="order-2 lg:order-last pt-10"
          primaryBtnClassName="px-12 bg-red-950"
          showInMobile={true}
        >
          <InfoList list={workingHours} id="expertHelp-list" />
        </BrandSection>
      </Section>
      <Section classNames="py-0">
        <BlueSection {...officeLocationsData} />
      </Section>
      <Section classNames="pt-10 pb-8 lg:py-12 bg-white">
        <RecommendedReads data={recommendedReadsData} />
      </Section>
      <Section classNames="bg-blue-base-white pt-8 pb-8 lg:pt-12 lg:pb-12">
        <GetInTouch />
      </Section>
    </Content>
  )
}

export default ContactUs
